/**
 * ZAXIA Staff Portal - Entry Point
 * Separate entry for staff application
 *
 * Phase P2.1-3: Wrapped with AuthProvider for global auth state
 */

// ─── Sentry (PILOT-1) ────────────────────────────────────────────────────────
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN as string | undefined,
  environment: import.meta.env.MODE,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  beforeSend(event) {
    if (event.request?.data) {
      const data = event.request.data as Record<string, unknown>;
      for (const key of ['guestName', 'roomNumber', 'name', 'email', 'phone']) {
        if (key in data) data[key] = '[Filtered]';
      }
    }
    return event;
  },
});
// ─────────────────────────────────────────────────────────────────────────────

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { StaffApp } from './StaffApp';
import { AuthProvider } from './context/AuthContext';
// Minimal CSS - no global styles
import './styles.css';

// Debug log
console.log('[STAFF] Loading staff portal...');

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<div style={{ color: '#fff', padding: '2rem' }}>Something went wrong.</div>}>
      <AuthProvider>
        <StaffApp />
      </AuthProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>
);
